import React from 'react';
import OpponentHUD from '../../OpponentHUD';
import { getTitleColorHex } from '../../constants/titleColors';
import { BARRIER_SPRITE_DISMANTLE_DELAY_MS } from '../../constants/battleHealthHud';
import './BattleOpponentHudPanel.css';

/**
 * Opponent HUD chrome + optional emote bubble (desktop + mobile battle).
 */
export default function BattleOpponentHudPanel({
  mobileLayout = false,
  opponentEmoteBubble = null,
  emoteDisplayText = '',
  opponent,
  opponentHealthDisplayText,
  opponentGeneral,
  effectiveOpponentUsername,
  effectiveOpponentTitleRaw,
  effectiveOpponentTitleColorKey,
  opponentDamageFlash,
  opponentFactionName,
  getTranslatedFactionName,
  resolveBattleTitleDisplay,
  opponentPreparationBonus,
  opponentDiplomaticAccord,
  showOpponentPrepBonusHud,
  opponentPrepTooltipForHud,
  opponentDiplomaticTooltipForHud,
  isTutorialMission,
  yourTurn,
  gameId,
  opponentRank,
  opponentPvpLadderRow,
  showOpponentBanner,
  getRankStyle,
  profileImage,
  profileImageStyle,
  isGeneralTarget,
  generalPortraitPointer,
  onGeneralPortraitClick,
}) {
  return (
    <>
      {opponentEmoteBubble && emoteDisplayText ? (
        <div
          className={[
            'battle-opponent-emote-bubble',
            mobileLayout ? 'battle-opponent-emote-bubble--mobile' : '',
          ].filter(Boolean).join(' ')}
        >
          <div className="battle-opponent-emote-bubble__tail" aria-hidden />
          <div className="battle-opponent-emote-bubble__tail-border" aria-hidden />
          <div className="battle-opponent-emote-bubble__body">{emoteDisplayText}</div>
        </div>
      ) : null}
      <OpponentHUD
        mobileLayout={mobileLayout}
        opponentName={effectiveOpponentUsername}
        opponentTitle={resolveBattleTitleDisplay(effectiveOpponentTitleRaw)}
        titleColor={getTitleColorHex(effectiveOpponentTitleColorKey)}
        health={opponent.health}
        healthDisplayText={opponentHealthDisplayText}
        barriersRemoved={opponent.barriersRemoved ?? []}
        barrierSpriteDelayMs={BARRIER_SPRITE_DISMANTLE_DELAY_MS}
        barrierVisualResetKey={gameId ?? ''}
        intel={opponent.intelligence}
        maxIntel={opponent.maxIntelligence ?? 8}
        profileImage={profileImage}
        profileImageStyle={profileImageStyle}
        factionName={opponentFactionName}
        translatedFactionName={getTranslatedFactionName(opponentFactionName)}
        isActiveTurn={!yourTurn}
        opponentRank={opponentRank}
        opponentPvpLadderRow={opponentPvpLadderRow}
        getRankStyle={getRankStyle}
        showOpponentBanner={showOpponentBanner}
        showOpponentBonusRow={!isTutorialMission}
        showOpponentPreparationBonus={showOpponentPrepBonusHud}
        opponentPreparationBonus={opponentPreparationBonus}
        opponentPreparationBonusUsed={opponent.preparationBonusUsed === true}
        opponentPreparationBonusTooltip={showOpponentPrepBonusHud ? opponentPrepTooltipForHud : ''}
        opponentDiplomaticAccord={opponentDiplomaticAccord}
        opponentDiplomaticAccordTooltip={opponentDiplomaticAccord ? opponentDiplomaticTooltipForHud : ''}
        yourTurn={yourTurn}
        isGeneralTarget={isGeneralTarget}
        onGeneralPortraitClick={onGeneralPortraitClick}
        generalPortraitPointer={generalPortraitPointer}
      />
    </>
  );
}
